<script>
  import { supabase } from "./supabaseClient";
  import { onMount } from "svelte";
  import Controller from "./Controller.svelte";
  import Member from "./Member.svelte";
  import Logs from "./Logs.svelte";

  let member;
  let isOpenedAbout = false;
  let isOpenedUpdateLog = false;

  let commentLogs = [];
  const reload = async () => {
    commentLogs = [];
    try {
      let { data, error } = await supabase
        .from("comment_log")
        .select(`*`)
        .order("created_at", { ascending: false })
        .limit(100);
      if (error) throw error;
      commentLogs = data;
    } catch (error) {
      alert(error);
    }
    member.viewCurrentMember();
  };

  const viewAbout = () => {
    isOpenedAbout = true;
  };
  const closeAbout = () => {
    isOpenedAbout = false;
  };
  const viewUpdateLog = () => {
    isOpenedUpdateLog = true;
  };
  const closeUpdateLog = () => {
    isOpenedUpdateLog = false;
  };

  onMount(async () => {
    reload();
  });
</script>

<div class="container">
  <div class="about">
    <a href="#" on:click={viewUpdateLog}>更新履歴</a>
    <a href="#" on:click={viewAbout}>About</a>
  </div>
  <h1 class="title">Retro Chat</h1>
  <hr />
  <Controller {reload} />
  <hr />
  <Member bind:this={member} />
  <Logs {commentLogs} />
  {#if isOpenedAbout}
    <div class="wrapper">
      <div class="about-container">
        <h3>About</h3>
        <p class="description">
          昔の個人サイト等によく設置されていたCGIチャットをそれっぽく再現したものです。使い方は雰囲気で察してください。
          <br />
          荒らしと判断される行為を繰り返し行ったユーザーは、チャットへの参加をご遠慮頂く場合がございます。ご了承ください。
        </p>
        <p>
          作った人：<a
            class="createdBy"
            href="https://twitter.com/de_teiu_tkg"
            target="_blank"
            rel="noopener"
          >
            @de_teiu_tkg
          </a>
        </p>
        <button on:click={closeAbout}>閉じる</button>
      </div>
    </div>
  {/if}
  {#if isOpenedUpdateLog}
    <div class="wrapper">
      <div class="about-container">
        <h3>更新履歴</h3>
        <ul class="description">
          <li>
            <span class="date">2021/10/23</span>
            <span class="detail">
              荒らし対策のため、アクセス制限機能を追加(管理人のみ使用)など
            </span>
          </li>
          <li>
            <span class="date">2021/10/11</span>
            <span class="detail">Retro Chat公開 </span>
          </li>
        </ul>
        <button on:click={closeUpdateLog}>閉じる</button>
      </div>
    </div>
  {/if}
</div>

<style>
  .title {
    margin: 0px;
    font-size: 2rem;
    text-align: center;
    color: brown;
  }
  .container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .about {
    text-align: right;
    padding: 3px 5px;
  }
  .wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .about-container {
    max-width: 95%;
    max-height: 95%;
    width: 680px;
    background-color: white;
    border: solid black 2px;
    padding: 5px;
    text-align: center;
  }
  .description {
    text-align: left;
  }
  .createdBy {
    color: blue;
  }
  .date {
    margin-right: 5px;
  }
</style>
